import { Adversary } from './adversaries';

export type CardState = 'hidden' | 'flipped' | 'matched';

export type GameCard = {
  instanceId: string;
  adversary: Adversary;
  state: CardState;
};

export type GameStatus = 'idle' | 'loading' | 'playing' | 'complete';

/**
 * Creates a shuffled deck of 16 cards (8 adversary pairs).
 * Uses Fisher-Yates shuffle with a provided seed array to avoid
 * Math.random() in render — caller controls randomness.
 */
export function buildDeck(adversaries: Adversary[], shuffleOrder: number[]): GameCard[] {
  const pairs: GameCard[] = [];
  adversaries.forEach((adv) => {
    pairs.push({ instanceId: `${adv.id}-a`, adversary: adv, state: 'hidden' });
    pairs.push({ instanceId: `${adv.id}-b`, adversary: adv, state: 'hidden' });
  });

  // Apply pre-computed shuffle order
  const deck: GameCard[] = new Array(pairs.length);
  for (let i = 0; i < shuffleOrder.length; i++) {
    deck[i] = pairs[shuffleOrder[i]];
  }
  return deck;
}

export function generateShuffleOrder(length: number): number[] {
  const arr = Array.from({ length }, (_, i) => i);
  // Fisher-Yates — called once outside render
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

// Scoring tiers
export function scoreTier(seconds: number, moves: number): { label: string; className: string } {
  if (seconds < 20) return { label: 'ELITE', className: 'tier-elite' };
  if (seconds <= 30) return { label: 'EXPERT', className: 'tier-expert' };
  if (seconds <= 40) return { label: 'ANALYST', className: 'tier-analyst' };
  return { label: 'RECRUIT', className: 'tier-recruit' };
}